const STORED_PREFIX = /^\d{13,14}_(sum[0-9a-f]{16}_)?/;

/**
 * The name a file was sent with, as the CDN keeps it: without the upload time and the entity mark it stores the file
 * under. Only for display: opening or deleting the file takes the stored name.
 */
export const originalFileName = (storedName: string): string =>
  storedName.replace(STORED_PREFIX, "");
